export class CachableData<T> {
  public Data: T;
  public AddedToCache: Date;
  public AbsoluteExpirationDate?: Date;

  constructor(opt?: Partial<CachableData<T>>) {
    Object.assign(this, opt);
  }
}
